export default __webpack_public_path__ + "static/media/CCDC_Logo.268ab13d.svg";